/**
 * Ksting
 *
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { string } from 'prop-types';

import styles from './logotypes-block.scss';

import EtonImage from '../../../../media/png/logotype-eton.png';
import HaglofsImage from '../../../../media/png/logotype-haglofs.png';
import HMImage from '../../../../media/png/logotype-hm.png';
import AdidasImage from '../../../../media/png/logotype-adidas.png';
import FlatteredImage from '../../../../media/png/logotype-flattered.png';
import GantImage from '../../../../media/png/logotype-gant.png';

/**
 * This is the LogotypesBlock component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 * @author Pelle Lundgren <pelle.lundgren@vntrs.com>
 *
 *
 * The logotype block now lives in the frontend to decrease the dependency on cloudinary for the logo images
 * Show probably be moved in the future to some other place so the KSTING team can update the images themselves
 *
 */
export default class LogotypesBlock extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    title: string,
    content: string,
  };

  renderItems() {
    const items = [
      {
        title: 'Eton',
        image: EtonImage,
        url: 'https://www.ksting.com/signup',
      },
      {
        title: 'Haglöfs',
        image: HaglofsImage,
        url: 'https://www.ksting.com/signup',
      },
      {
        title: 'H&M',
        image: HMImage,
        url: 'https://www.ksting.com/signup',
      },
      {
        title: 'Adidas',
        image: AdidasImage,
        url: 'https://www.ksting.com/signup',
      },
      {
        title: 'Flattered',
        image: FlatteredImage,
        url: 'https://www.ksting.com/signup',
      },
      {
        title: 'Gant',
        image: GantImage,
        url: 'https://www.ksting.com/signup',
      },
    ];

    return items.map(({ image, title, url }, i) => (
      <div className={styles.item} key={i}>
        <img src={image} alt={title} className={styles.logotype} />
        {url && (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
          >
            {title}
          </a>
        )}
      </div>
    ));
  }

  /**
   * Render LogotypesBlock.
   *
   * @return {Object}
   */
  render() {
    const { title, content } = this.props;

    return (
      <section className={styles.wrapper}>
        {title && (
          <div className={styles.row}>
            <header className={styles.header}>
              <h2>{title}</h2>
              <p>{content}</p>
            </header>
          </div>
        )}

        <div className={styles.row}>{this.renderItems()}</div>
      </section>
    );
  }
}
